import { Box, Typography, Chip } from "@mui/material";
import { useTheme } from "@mui/material/styles";

import {
  LocationOnIcon,
  SchoolIcon,
  PersonIcon,
} from "../../../../../../2_ksbHub/icons/icons";

import { useAppContext } from "../../../../../../2_ksbHub/context/appContext";

export default function BszReservationResult({
  reservation,
  remaining,
  showTime,
}) {
  const theme = useTheme();
  const { isMobile } = useAppContext();

  const Icon = reservation.type === "Lehrperson" ? SchoolIcon : PersonIcon;

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: isMobile ? "column" : "row",
        alignItems: isMobile ? "flex-start" : "center",
        py: isMobile ? 0.75 : 0.5,
        px: isMobile ? 0 : 0.5,
        borderBottom: "1px solid rgba(255,255,255,0.05)",
        gap: isMobile ? 0.3 : 1,
        overflow: "hidden",
      }}
    >
      {/* NAME */}
      <Box
        sx={{
          flex: isMobile ? "0 0 50%" : "0 0 160px",
          minWidth: 0,

          display: "flex",
          alignItems: "center",
          gap: 0.5,
        }}
      >
        <Icon
          sx={{
            fontSize: 18,
            opacity: 0.5,
            flexShrink: 0,
          }}
        />

        <Typography
          variant="body2"
          sx={{
            fontWeight: 250,
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          }}
        >
          {reservation.name}
        </Typography>
      </Box>

      {/* STATUS */}
      <Box
        sx={{
          flex: "1 1 auto",
          minWidth: 0,
          display: "flex",
          alignItems: "center",
          gap: 0.5,
          flexWrap: "wrap",
        }}
      >
        <Chip
          icon={!isMobile ? <LocationOnIcon /> : null}
          label={
            showTime && remaining !== null
              ? `${reservation.roomName} · ${remaining} min`
              : reservation.roomName
          }
          size="small"
          sx={{
            backgroundColor:
              showTime && remaining !== null
                ? remaining > 4
                  ? theme.palette.levels.green
                  : theme.palette.levels.red
                : undefined,

            color: showTime && remaining !== null ? "white" : undefined,

            "& .MuiChip-icon": {
              color: showTime && remaining !== null ? "white" : undefined,
            },
          }}
        />

        {!isMobile && (
          <Chip label={reservation.type} size="small" variant="outlined" />
        )}
      </Box>
    </Box>
  );
}
